import Vue from 'vue';
import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';
import Pusher from 'pusher-js/with-encryption';
import * as nacl from 'tweetnacl';
import { GLOBAL, EVENTS } from '@/app/shared/utils/constants';

export default {
    data() {
        return {
            broadcasting: {
                echo: null,
                subscribedChannels: {
                    public: [],
                    private: [],
                }
            },
        }
    },
    beforeDestroy(){
        this.disconnectBroadcasting();
    },
    computed: {
        config() {
            return this.$root.$env ?? {};
        },
        broadcastingConfig() {
            return this.config?.BROADCASTING ?? {};
        },
        broadcastingActive() {
            return !!this.broadcastingConfig.ENABLED;
        },
        currentUser: {
            cache: false,
            get(){ return this.$auth.user() }
        },
        currentUserId: {
            cache: false,
            get(){ return this.currentUser ? this.currentUser.id : null }
        },
        authorizationToken: {
            cache: false,
            get(){ return this.$auth.token() }
        },
        notifications: {
            cache: false,
            get(){ return this.$store.getters.notifications.reverse() }
        },
        isConnected: {
            cache: false,
            get(){
                return (this.broadcasting.echo && this.broadcasting.echo.connector.pusher.connection.connection !== null)
            }
        },
        channels: {
            cache: false,
            get(){
                let channels = {};
                channels[`public`] = {
                    '.message': (payload) => {
                        this.$eventBus.publish(GLOBAL.MODULE, EVENTS.SHOW_MESSAGE, {'title': payload.title ?? 'broadcasting.title', ...payload});
                    },
                };
                // [TODO]
                // channels[`private:message.${ this.currentUserId }`] = {
                //     '.message': (payload) => {
                //         this.$eventBus.publish(GLOBAL.MODULE, EVENTS.SHOW_MESSAGE, {'title': payload.title ?? 'broadcasting.title', ...payload});
                //     },
                // };
                // channels[`private:notification.${ this.currentUserId }`] = {
                //     '.message': (payload) => {
                //         this.$eventBus.publish(GLOBAL.MODULE, EVENTS.SHOW_NOTIFICATION, {'title': payload.title ?? 'broadcasting.title', ...payload});
                //     },
                // };
                return channels;
            }
        }
    },
    watch: {
        currentUser: {
            handler(value){
                this.setAuthorizationBroadcasting();
                (value !== null ? this.bindChannels('private') : this.disconnectChannels('private'))
            }
        },
        isConnected: {
            handler(value){
                this.$emit('broadcasting:status', value)
            }
        },
        broadcastingActive: {
            immediate: true,
            handler(value){
                if(value) {
                    this.connectBroadcasting();
                }else{
                    this.disconnectBroadcasting();
                }
                this.setBroadcastingEnabled(value);
            }
        }
    },
    methods: {
        /** Connect Echo **/
        connectBroadcasting(){
            if(!this.broadcastingActive) return;

            // Enable pusher logging - don't include this in production
            if(this.$root.$env.DEBUG){
                Pusher.logToConsole = true;
                Pusher.log = (msg) => {
                    console.log(msg);
                };
            }

            try {
                if(!this.broadcasting.echo){
                    let configEcho = this.broadcastingConfig;

                    this.broadcasting.echo = new Echo({
                        broadcaster: configEcho.BROADCASTER,
                        key: configEcho.KEY,
                        cluster: configEcho.CLUSTER ?? 'mt1',
                        wsHost: configEcho.HOST ?? '',
                        wsPort: configEcho.PORT ?? 80,
                        wssPort: configEcho.PORT_HTTPS ?? 443,
                        wsPath: configEcho.PATH ?? '',
                        forceTLS: (configEcho.SCHEME ?? 'https') === 'https',
                        authEndpoint: `${this.config.API_URL}/broadcasting/auth`, // '/broadcasting/auth',
                        // userAuthentication: {
                        //     endpoint: '/broadcasting/user-auth',
                        //     headers: {},
                        // },
                        csrfToken: null,
                        bearerToken: null,
                        encrypted: configEcho.ENCRYPTED ?? true,
                        enableStats: false,
                        enabledTransports: ['ws', 'wss'],
                        disabledTransports: ['sockjs', 'xhr_polling', 'xhr_streaming'],
                        auth: {
                            headers: {
                                Authorization: null,
                            }
                        },
                        // This parameter shouldn't be necessary, but if you remove it it gives the error:
                        // "Tried to subscribe to a private-encrypted- channel but no nacl implementation available"
                        nacl: nacl,
                        //csrfToken: null,
                        //namespace: 'App',
                    });

                    this.broadcasting.echo.connector.pusher.connection.bind("state_change", (states) => {
                        const {previous, current} = states;
                        switch (current) {
                            case "connected":
                                this.bindChannels();
                                break;
                            case "error":
                                break;
                            case "unavailable":
                            case "failed":
                            case "disconnected":
                                this.disconnectChannels();
                                break;
                        };
                        this.setBroadcastingState(current);
                    });

                    Vue.prototype.$echo = this.broadcasting.echo;
                }
                this.setAuthorizationBroadcasting();
                this.broadcasting.echo.connect();

            } catch (error) {
                if(this.$root.$env.DEBUG){
                    console.error(error);
                }
                console.error('Unable to activate broadcast');
            }
        },
        setAuthorizationBroadcasting() {
            let echo = this.broadcasting.echo;
            if(echo) {
                let token = this.authorizationToken;
                echo.options.bearerToken =  token;
                echo.connector.options.auth.headers.Authorization = token ? `Bearer ${token}` : null;
            }
        },
        /** Disconnect Echo **/
        disconnectBroadcasting(key='all'){
            let echo = this.broadcasting.echo;
            if(!echo) return;

            this.disconnectChannels(key);
            if(key == 'all') {
                // echo.connector.pusher.disconnect();
                echo.disconnect();
                this.broadcasting.echo = null;
                Vue.prototype.$echo = null;
            }
        },
        /** Disconnect Channels **/
        disconnectChannel(channelName){
            let echo = this.broadcasting.echo;
            if(!echo) return;

            let subscribedChannels = this.broadcasting.subscribedChannels;
            // echo.leaveAllChannels();
            let channel = null;
            if(channel = subscribedChannels.private.find(channel => channel == channelName)){
                echo.leave(channel);
                subscribedChannels.private.splice(0);
            }else if(channel = subscribedChannels.public.find(channel => channel == channelName)){
                echo.leave(channel);
                subscribedChannels.public.splice(0);
            }
        },
        /** Disconnect Channels **/
        disconnectChannels(channels='all'){
            let echo = this.broadcasting.echo;
            if(!echo) return;

            let subscribedChannels = this.broadcasting.subscribedChannels;
            if(channels == 'all' || channels == 'private' || channels == 'public') {
                if(channels == 'all' || channels == 'private') {
                    subscribedChannels.private.forEach(channel => channel ? echo.leave(channel) : null);
                    subscribedChannels.private.splice(0);
                }
                if(channels == 'all' || channels == 'public') {
                    subscribedChannels.public.forEach(channel => channel ? echo.leave(channel) : null);
                    subscribedChannels.public.splice(0);
                }
            }else{
                let _channels = Object.keys(channels);
                subscribedChannels.private.filter(channel => _channels.includes(channel)).forEach(channel => {
                    if(channel) {
                        echo.leave(channel);
                        let idx = subscribedChannels.private.indexOf(channel);
                        subscribedChannels.private.splice(idx);
                    }
                });
                subscribedChannels.public.filter(channel => _channels.includes(channel)).forEach(channel => {
                    if(channel) {
                        echo.leave(channel);
                        let idx = subscribedChannels.public.indexOf(channel);
                        subscribedChannels.public.splice(idx);
                    }
                });
            }
        },
        /** Bind Channels **/
        bindChannels(channels = 'all'){
            let echo = this.broadcasting.echo;
            if(!echo) return;

            this.setAuthorizationBroadcasting();

            if(channels == 'all') {
                this.disconnectChannels(channels);
            }

            let subscribedChannels = this.broadcasting.subscribedChannels;
            let _channels = channels == 'all' ? this.channels : channels;
            if(_channels) {
                Object.entries(_channels).forEach(([key, events]) => {
                    let channelName = key;
                    let _channel = null;
                    if(key.startsWith('private:')) {
                        channelName = key.replace('private:', '');
                        _channel = this.currentUserId && !subscribedChannels.private.includes(channelName) ? echo.private(channelName) : null;
                    } else if(key.startsWith('private-encrypted:')) {
                        channelName = key.replace('private-encrypted:', '');
                        _channel = this.currentUserId && !subscribedChannels.private.includes(channelName) ? echo.encryptedPrivate(channelName) : null;
                    } else if(key.startsWith('presence:')) {
                        channelName = key.replace('presence:', '');
                        _channel = this.currentUserId && !subscribedChannels.private.includes(channelName) ? echo.join(channelName) : null;
                    } else if(!subscribedChannels.public.includes(channelName)) {
                        _channel = echo.channel(channelName);
                    }

                    if(_channel && events) {
                        Object.keys(events).forEach(function(key){
                            // Bind the VM as second parameter
                            _channel.listen(`.${key}`, (payload) => {
                                events[key].bind(this)(payload);
                            });
                        }, this);

                        if(channelName != key) {
                            this.broadcasting.subscribedChannels.private.push(channelName);
                        }else{
                            this.broadcasting.subscribedChannels.public.push(channelName);
                        }
                    }
                });
            }

            // let vm = this;
            // this.echo.private('App.User' + '.' + this.currentUser.id)
            //     .notification((object) => vm.$store.commit('addNotification', object));
            // for local data use
            // this.echo.private('App.User' + '.' + this.currentUser.id)
            //     .notification((object) => vm.notifications.push(object))
        },
        subscribeChannels(channels) {
            this.bindChannels(channels)
        },
        unsubscribeChannels(channels) {
            this.disconnectChannels(channels);
        },
        setBroadcastingEnabled(enabled = true, state = undefined) {
            this.$store.dispatch('setBroadcastingEnabled', {
                enabled,
                state,
            });
        },
        setBroadcastingState(state = undefined) {
            this.$store.dispatch('setBroadcastingState', {
                state
            });
        },
    }
}